import React, { ImgHTMLAttributes, memo, ReactElement } from 'react';
import DefaultVideo from '../../assets/no-video.svg';

interface AppImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
  errorFallback?: ReactElement;
  isLoading: boolean;
}

export const AppImage = memo((props: AppImageProps) => {
  const { className, src, alt = 'image', errorFallback, isLoading, ...otherProps } = props;

  return !isLoading ? (
    <img className={className} src={src} alt={alt} {...otherProps} />
  ) : (
    <img className={className} src={DefaultVideo} alt={alt} {...otherProps} />
  );
});
